import React from "react";
import Select from "react-select";
import { TIME_SLOT_OPTIONS } from "./common";

/**
 * Reusable time slot dropdown (30-min intervals, 9 AM – 8 PM).
 *
 * Props:
 *   value        - currently selected time string (e.g. "9:30 AM")
 *   onChange      - callback receiving the selected time string
 *   placeholder   - placeholder text (default "Select Time")
 *   label         - optional label text
 *   required      - show red asterisk
 *   disabled      - disable the select
 *   startTime     - optional: if set, only show slots >= this time
 *   endTime       - optional: if set, only show slots <= this time
 *   disableBefore - optional: if set, slots < this time are shown but disabled
 */
const TimeSlotSelect = ({
  value,
  onChange,
  placeholder = "Select Time",
  label,
  required = false,
  disabled = false,
  startTime,
  endTime,
  disableBefore,
}) => {
  const options = TIME_SLOT_OPTIONS.filter((opt) => {
    if (startTime && !endTime) return opt.value >= startTime;
    if (!startTime && endTime) return opt.value <= endTime;
    if (startTime && endTime) return opt.value >= startTime && opt.value <= endTime;
    return true;
  }).map((opt) => ({
    ...opt,
    isDisabled: disableBefore ? opt.value < disableBefore : false,
  }));

  const selected = value ? { value, label: value } : null;

  return (
    <div>
      {label && (
        <label style={{ fontWeight: 600, fontSize: "14px", color: "black", display: "block", marginBottom: "4px" }}>
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </label>
      )}
      <Select
        placeholder={placeholder}
        value={selected}
        options={options}
        isDisabled={disabled}
        onChange={(e) => onChange(e?.value || "")}
      />
    </div>
  );
};

export default TimeSlotSelect;
